import React, { createContext } from "react";

export interface JourneyRunContextType {
  isRunning: boolean;
  isForced: boolean;
  setIsRunning: (running: boolean) => void;
  setIsForced: (forced: boolean) => void;
}

export const JourneyRunContext = createContext<JourneyRunContextType>({
  isRunning: false,
  isForced: false,
  setIsRunning: () => {},
  setIsForced: () => {},
});
